<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-avatar class="mr-3" size="48">
                    <v-avatar color="secondary" size="65">
                      <v-img
                        v-if="$getDeepObj(detail, 'ptk.data.foto')"
                        :src="$getDeepObj(detail, 'ptk.data.foto')"
                      ></v-img>
                      <v-icon v-else dark large>mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                      {{ $getDeepObj(detail, 'ptk.data.nama') || '-' }}
                    </div>
                    <div>
                      <span class="subtitle-2 black--text">No.UKG:</span>
                      {{ $getDeepObj(detail, 'ptk.data.no_ukg') || '-' }}
                    </div>
                    <div class="my-auto" style="line-height: 1">
                      <v-icon class="mr-1" color="primary" small dark left @click="onCall(item)">
                        mdi-account
                      </v-icon>
                      {{ $getDeepObj(detail, 'm_unsur_psp.data.keterangan') }}
                    </div>
                    <div class="my-auto" style="line-height: 1">
                      <v-icon v-if="$getDeepObj(detail, 'no_wa')" class="mr-1" color="success" small dark left>
                        mdi-whatsapp
                      </v-icon>
                      {{ $getDeepObj(detail, 'no_wa') || $getDeepObj(detail, 'ptk.data.no_hp') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <span class="grey--text mb-1" style="font-size: 13px">
                      {{ jenis === 'pelatih-ahli' ? 'Instansi Asal' : 'Informasi Sekolah' }}
                    </span>
                    <div class="font-weight-regular" style="font-size: 15px">
                      <span>
                        {{
                          $getDeepObj(detail, 'sekolah_id')
                            ? $getDeepObj(detail, 'sekolah.data.nama') || ''
                            : $getDeepObj(detail, 'instansi_nama') || ''
                        }}
                      </span>
                      <div class="body-2 mt-1" v-if="$getDeepObj(detail, 'sekolah_id')">
                        <span class="font-weight-bold">NPSN:</span> {{ $getDeepObj(detail, 'sekolah.data.npsn') }}
                      </div>
                      <div class="body-2" v-if="$getDeepObj(detail, 'sekolah_id')">
                        <span class="font-weight-bold">Status:</span>
                        {{ +$getDeepObj(detail, 'sekolah.data.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <span class="grey--text" style="font-size: 13px">
                      {{ jenis === 'pelatih-ahli' ? 'Alamat Instansi Asal' : 'Alamat Sekolah' }}
                    </span>
                    <div class="body-2 font-weight-regular">
                      <template v-if="$getDeepObj(detail, 'sekolah_id')">
                        <span>{{ $getDeepObj(detail, 'sekolah.data.m_kota.data.keterangan') }}</span>
                        <br />Prov. {{ $getDeepObj(detail, 'sekolah.data.m_propinsi.data.keterangan') }}
                      </template>
                      <template v-else>
                        <span v-if="$getDeepObj(detail, 'instansi_k_kota')">
                          {{ $getDeepObj(detail, 'm_kota_instansi.data.keterangan') }}
                        </span>
                        <br v-if="$getDeepObj(detail, 'instansi_k_kota')" />
                        Prov. {{ $getDeepObj(detail, 'm_propinsi_instansi.data.keterangan') }}
                      </template>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="1">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <span class="grey--text" style="font-size: 13px">Angkatan</span>
                    <div class="subtitle-1 font-weight-medium secondary--text">
                      {{ $getDeepObj(detail, 'gelombang') || '-' }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <span class="grey--text" style="font-size: 13px">Status</span>
                    <div class="body-2 font-weight-regular">
                      <v-chip :class="[+$getDeepObj(detail, 'is_aktif') === 1 ? 'green' : 'red', 'white--text']">
                        {{ +$getDeepObj(detail, 'is_aktif') === 1 ? 'Pelaksana' : 'Mengundurkan Diri' }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" flat>
      <v-card-text class="pa-5">
        <v-container>
          <template v-if="jenis === 'peserta'">
            <h2 class="black--text mb-3">Berkas pengunduran diri peserta PSP</h2>
            <div class="grey--text mb-1">
              Unggah berkas pengunduran diri peserta PSP <span class="red--text">*</span>
            </div>
            <v-file-input
              v-model="form['berkas']"
              :accept="['application/pdf,image/*']"
              outlined
              dense
              hide-details
              prepend-icon=""
              @click:append="onHandleClickAppend"
              ref="vFileInput"
              append-icon="mdi-paperclip"
              placeholder="Unggah berkas pendukung"
            />
          </template>
          <template v-else>
            <v-row>
              <v-col cols="12" md="6">
                <div class="subtitle-1 black--text">Pilih status Fasilitator (FSP)</div>
                <v-radio-group row v-model="form.is_aktif">
                  <v-radio label="Pelaksana" :value="1"></v-radio>
                  <v-radio label="Diskualifikasi" :value="0"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" v-if="form.is_aktif === 0">
                <div class="grey--text mb-1"> Pilih alasan diskualifikasi <span class="red--text">*</span> </div>
                <v-select
                  v-model="form['alasan_diskualifikasi']"
                  :items="M_ALASAN"
                  placeholder="Pilih alasan diskualifikasi"
                  outlined
                  dense
                  single-line
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="form['alasan_diskualifikasi'] === 'Alasan Lainnya'">
              <v-col cols="12">
                <div class="grey--text mb-1"> Tuliskan Alasan Lainnya <span class="red--text">*</span> </div>
                <v-text-field
                  v-model="form['alasan_diskualifikasi_lain']"
                  outlined
                  dense
                  hide-details
                  placeholder="Tuliskan Alasan Lainnya"
                />
              </v-col>
            </v-row>
            <v-row v-if="form.is_aktif === 0">
              <v-col cols="12">
                <div class="grey--text mb-1">
                  Unggah dokumen pendukung alasan tidak menjadi PSP <span class="red--text">*</span>
                </div>
                <div class="black--text" v-if="berkas && berkas.url_berkas">
                  <v-btn
                    small
                    depressed
                    text
                    color="info"
                    class="pa-0 text-none subtitle-1"
                    :href="berkas.url_berkas"
                    target="_blank"
                  >
                    Lihat Berkas
                  </v-btn>
                  <v-btn small depressed text color="error" class="pa-0" @click="onDelete">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <v-file-input
                  v-else
                  v-model="form['berkas']"
                  :accept="['application/pdf,image/*']"
                  outlined
                  dense
                  hide-details
                  prepend-icon=""
                  @click:append="onHandleClickAppend"
                  ref="vFileInput"
                  append-icon="mdi-paperclip"
                  placeholder="Unggah berkas pendukung"
                />
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FormAjuan',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    jenis: {
      type: String,
      default: 'peserta',
    },
  },
  data() {
    return {
      form: {},
      berkas: {},
      M_ALASAN: [
        'Mengundurkan Diri',
        'Meninggal Dunia',
        'Kesehatan Tidak Memungkinkan',
        'Tidak Mendapatkan Persetujuan Atasan',
        'Tidak Mendapat Rekomendasi Keluarga',
        'Ditugaskan Di Instansi Lain',
        'Alasan Lainnya',
      ],
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'berkas', {});
    },

    onHandleClickAppend() {
      this.$refs[`vFileInput`][0].$el.querySelector('input').click();
    },

    getValue() {
      return this.form;
    },

    initForm(data) {
      if (this.jenis === 'peserta') return;

      const form = ['is_aktif', 'alasan_diskualifikasi'];
      for (const item of form) {
        const value = this.$getDeepObj(data, item) || '';
        if (value && item === 'alasan_diskualifikasi') {
          this.$set(this.form, item, this.M_ALASAN.includes(value) ? value : 'Alasan Lainnya');
          this.$set(this.form, 'alasan_diskualifikasi_lain', !this.M_ALASAN.includes(value) ? value : '');
        } else this.$set(this.form, item, +value);
      }

      const berkases = this.$getDeepObj(data, 'psp_profil_berkases.data');
      const berkas = berkases.filter((item) => item.k_profil_berkas_psp === 22)[0] || {};
      if (this.$isObject(berkas)) this.berkas = berkas;
    },

    onDelete() {
      this.berkas = {};
    },
  },
  watch: {
    detail: 'initForm',
  },
};
</script>

<style scoped></style>
